<template>
  <b-container fluid>
    <b-row class="justify-content-center">
      <b-col cols="8">
				<b-container fluid>
					<b-row class="ribbon">
						<b-col sm="12" md="2">
							<img :src="imageSrc" alt="Logo" />
						</b-col>
						<b-col sm="12" md="10">
							<b-row v-if="title">
								<p class="ribbon__title">
									{{ title }}
								</p>
							</b-row>
							<b-row v-for="info in contentInfo" :key="info.title">
								<b-col>
									<p v-if="info.title" class="ribbon__subtitle">
										{{ info.title }}
									</p>
									<div v-html="sanitizedContent(info.content)" class="ribbon__content"></div>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</b-container>
			</b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    title: String,
    image: Object,
    contentInfo: Array,
    withBackground: Boolean
  },
  computed: {
    imageSrc() {
      return `/strapi/${this.image.data.attributes.url}`
    }
  },
  methods: {
    sanitizedContent(content) {
      return DOMPurify.sanitize(marked(content))
    }
  }
}
</script>

<style scoped src="@/assets/css/common-ribbon.css"/>
